import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enterprise-details',
  templateUrl: './enterprise-details.component.html',
  styleUrls: ['./enterprise-details.component.scss']
})
export class EnterpriseDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
